import React,{useState,useRef,useEffect} from 'react';
import { Form, Input, InputNumber,Tag,Button ,Col, Row,Spin,DatePicker, Select } from "antd";
import { kodEbEditorType, kodEbTypeCode } from "./Enum";
import * as util from "./Util";
import locale from './trLocale';

const {Option} = Select;

const formItemStyle = {
    marginLeft: 20,
    marginTop: 20
};



const DynamicFormItem = (props) => {
  

    const form = Form.useForm(props.form);
    const [spining, setSpining] = useState(false);

    // TODO : Tag Geliştirme
   // const [inputTagVal, setInputTagVal] = useState('');
   // const [numberTagVal, setNumberTagVal] = useState('');
   // const [dateTimeTagVal, setDateTimeTagVal] = useState('');

    const getParserVal = (ozellik,value) => {
        switch(ozellik.VeriTipi) {  
            case kodEbTypeCode.Decimal :
            case kodEbTypeCode.Double  :
                return value.replace(/^\d+\.\d{0,2}$/);
            case kodEbTypeCode.Int64  :
                return parseInt(value)
            default : 
                return value;    
        }
    }

    const handleClose = async(formObjectId, removedTag) => {
        setSpining(true);
        const newTags = form[0].getFieldValue(formObjectId).filter((tag) => tag !== removedTag);
        form[0].setFieldsValue({ [formObjectId]: newTags });
        setSpining(false);
    }

    const handleInputConfirm = async(id,val) => {

        setSpining(true);
        var tags = form[0].getFieldValue(id);
        
        if(val){
            if(util.isNullOrEmptyOrUndefined(tags)){
                form[0].setFieldsValue({ [id]: [val] });         
            }else if(tags.indexOf(val) === -1){
                tags.push(val);
                form[0].setFieldsValue({ [id]: tags });
            }
        }    

        console.log("form", form);
      };

    const GetFormItemLabel = (key) => {
        var objectId = key.Ozellik.Objectid;
        var basvuruOzellik = form[0].getFieldValue(key.Ozellik.Objectid);        
        
        switch(key.Ozellik.Editortipi) {
            case kodEbEditorType.InputNumber:
                return <InputNumber style={{ width: '100%' }} min={key.MinDeger} max={key.MaxDeger} parser={(value) => getParserVal(key.Ozellik,value)} />    
            case kodEbEditorType.Input :     
                return <Input style={{ width: '100%' }}/>
            case kodEbEditorType.InputTag :  
                return (
                    <> 
                    <Row>
                        <Col span={12}>
                            <Input
                                style={{width : '95%'}}
                                onBlur={async(e)  => {await handleInputConfirm(objectId,e.target.value);   setSpining(false); }}
                                onPressEnter={async(e)  => { await handleInputConfirm(objectId,e.target.value);   setSpining(false); }}
                                placeholder=' Eklemek İçin Tıklayınız.'
                               
                            />                           
                        </Col>
                        <Col span={12}>
                            {basvuruOzellik != null && basvuruOzellik.map((tag) => {
                                return (
                                    <span key={tag} style={{ display: 'inline-block',margin:2 }}>
                                        <Tag closable onClose={async(e) => { await handleClose(objectId, tag); }}>
                                            {tag}
                                        </Tag>
                                    </span>
                                );
                            })}
                        </Col>
                    </Row>

                    </>
                    
                );
            case kodEbEditorType.InputNumberTag :  
                return (
                    <> 
                    <Row>
                        <Col span={12}>
                            <InputNumber
                                style={{width : '95%'}}
                                onBlur={async(e)  => {await handleInputConfirm(objectId,e.target.value);     setSpining(false); }}
                                onPressEnter={async(e)  => { await handleInputConfirm(objectId,e.target.value);   setSpining(false); }}
                                placeholder=' Eklemek İçin Tıklayınız.'
                               
                            />        
                        </Col>
                        <Col span={12}>
                            {basvuruOzellik != null && basvuruOzellik.map((tag) => {
                                return (
                                    <span key={tag} style={{ display: 'inline-block',margin:2 }}>
                                        <Tag closable onClose={async(e) => { await handleClose(objectId, tag); }}>
                                            {tag}
                                        </Tag>
                                    </span>
                                );
                            })}
                        </Col>
                    </Row>

                    </>
                    
                )   
            case kodEbEditorType.DateTimeTag :  
                return (
                    <> 
                    <Row>
                        <Col span={12}>
                            <DatePicker
                                    style={{width : '95%'}}
                                    locale={locale}
                                    onBlur={async(e)  => {await handleInputConfirm(objectId,e.target.value);     setSpining(false); }}
                                    onChange={async(e,val)  => {await handleInputConfirm(objectId,val);  setSpining(false); } }
                                    placeholder=' Eklemek İçin Tıklayınız.'
                                
                            />           
                        </Col>
                        <Col span={12}>
                            {basvuruOzellik != null && basvuruOzellik.map((tag) => {
                                return (
                                    <span key={tag} style={{ display: 'inline-block',margin:2 }}>
                                        <Tag closable onClose={async(e) => { await handleClose(objectId, tag); }}>
                                            {tag}
                                        </Tag>
                                    </span>
                                );
                            })}
                        </Col>
                    </Row>

                    </>
                    
                )   
            case kodEbEditorType.MultiSelect:
                    return  <Select mode="tags" options={key.EditorData} /> 
            case kodEbEditorType.Select:
                        return  <Select options={key.EditorData} /> 
            default :
                return <Input style={{ width: '100%' }} defaultValue={null}/>
        }
    }
    return(

        <>
            {props.dynamicFormItem.length > 0 && 
           
                <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
                    
                    {props.dynamicFormItem.map(key => {
                        return(
                                    <Form.Item label= {key.Ozellik.Etiket} 
                                            name= {key.Ozellik.Objectid} 
                                            key= {key.Ozellik.Adi}                     
                                            style={formItemStyle}
                                            labelAlign="left"
                                            rules={[ { required: key.ZorunluMu}]}
                                            help={key.Aciklama}> 
                                            {GetFormItemLabel(key)}
                                    </Form.Item>
                                )
                        })}
                    
                </Spin>
            }
        </>
    );
}

export default DynamicFormItem;